import * as React from 'react';

import { useIsDesktop } from '@cian/valuation-utils-component';

import { isNavigatorShareSupported } from './utils';
import { ShareReportDesktop } from './ShareReportDesktop';
import { ShareReportMobile } from './ShareReportMobile';
import { useSelector } from 'react-redux';
import { getReportState } from '../../selectors/report';
import { selectIsWebview } from '../../selectors/page';

export const ShareReportContainer: React.FC = () => {
  const isDesktop = useIsDesktop();
  const isWebview = useSelector(selectIsWebview);
  const { shareReportUrl = '' } = useSelector(getReportState);

  if (!isDesktop && isNavigatorShareSupported()) {
    return <ShareReportMobile url={shareReportUrl as string} />;
  }

  return <ShareReportDesktop url={shareReportUrl as string} isWebview={isWebview} />;
};

ShareReportContainer.displayName = 'ShareReportContainer';
